export const consumptionClassColors = {
  'A': '#00ff00',
  'B': '#4cff00',
  'C': '#b2ff00',
  'D': '#ffff00',
  'E': '#ffb200',
  'F': '#ff4c00',
  'G': '#ff0000',
  'H': '#7f7f7f',
  'I': '#262626'
}

export const mapMarkerSizes = {
  min: 5,
  max: 20
}

export const mapboxSetup = {
  accessToken: 'pk.eyJ1IjoibmVnYXdhdHQiLCJhIjoiY2puMnk2cjlnMjk1aTNwcWw1ZGRvMGtoZyJ9.Nx_kjN-zZPQR6qC40BlaEg',
  style: 'mapbox://styles/negawatt/cjn46kvc990772sqy9cfk4bx1'
}



// WEBPACK FOOTER //
// ./src/constants.js